import { connect } from 'react-redux';
import withBaseDrawer from 'components/common/Drawers/withBaseDrawer';
import compose from 'ramda/src/compose';
import { updateTask } from 'redux-core/tasks/actions';
import { closeAllDialogs } from 'redux-core/dialogs/actions';

const mapDispatchToProps = { updateTask, closeAllDialogs };

export default compose(connect(null, mapDispatchToProps), withBaseDrawer);
